module.exports = __webpack_public_path__ + "static/media/logo.70f6a096.png";